import * as React from "react";
const SvgConferencePhone = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.332 2.332A2.751 2.751 0 0 1 5 .25h4c1.259 0 2.32.846 2.646 2H21A2.75 2.75 0 0 1 23.75 5v14A2.75 2.75 0 0 1 21 21.75h-9.354a2.751 2.751 0 0 1-2.646 2H5a2.751 2.751 0 0 1-2.668-2.082A2.751 2.751 0 0 1 .25 19V5c0-1.288.886-2.37 2.082-2.668ZM2.25 4c-.304.228-.5.591-.5 1v14c0 .409.196.772.5 1V4Zm9.5 16.25H21c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25h-9.25v16.5ZM10.25 3c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v18c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25V3Zm3 4.5a2.25 2.25 0 0 1 2.25-2.25h3a2.25 2.25 0 0 1 0 4.5h-3a2.25 2.25 0 0 1-2.25-2.25Zm2.25-.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3ZM14.25 13a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5h-4Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgConferencePhone;
